import styled from 'styled-components';

export const HeaderStyled = styled.div`
  width: 100%;
  display: flex;
`;

export const HeaderDataContainerStyled = styled.div<{
  isSortable: boolean;
  sortable: boolean;
  width: number;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 7px;
  width: ${({ width }) => `${width}px`};
  ${({ isSortable, sortable }) => isSortable && sortable && { cursor: 'pointer' }};
`;

export const EmptyTableRowStyled = styled.div<{ emptyRows: number; rowHeight: number }>`
  ${({ emptyRows, rowHeight }) => `height: ${(rowHeight || 34) * emptyRows}px`};
`;

export const TableContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const TableContentContainerStyled = styled.div`
  overflow-x: auto;
`;

export const TableDataContainerStyled = styled.div`
  display: grid;
  padding: 0px 14px;
`;

export const EmptyTableRowsContainerStyled = styled.div<{ emptyRows: number; rowHeight: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ emptyRows, rowHeight }) => `height: ${(rowHeight || 44) * emptyRows}px`};
  width: 100%;
`;

export const NoResultsFoundContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;
